<template>
  <header
    :class="[noBottomLine ? 'header-no-bottom-line' : '']"
    v-if="sourceForm !== SOURCEFORM_TMBD && !isMPSdtj"
  >
    <div class="left" @click="onHomeClick" v-show="showHome && !showBack">
      <icon>tab_shouye</icon>
    </div>
    <div class="left" @click="goBack" v-show="showBack">
      <img
        src="../../image/global/iconLeftBack@3x.png"
        width="11px"
        height="19px"
        alt=""
      />
    </div>
    <div :class="['title', custonmClass]">
      <slot name="title">
        {{ titleProps || routerTitle }}
      </slot>
    </div>
    <div class="right">
      <slot name="right"> </slot>
    </div>
  </header>
</template>
<script>
import icon from "../components/icon";
import CONSTANT from "../constant/cookie";
import cookie from "../lib/cookie";
import { getQueryUrl } from "../util/getQueryUrl.js";
import { SOURCEFORM_TMBD } from "../constant/consts.js";
export default {
  name: "my-header",
  data() {
    return { sourceForm: "h5", SOURCEFORM_TMBD };
  },
  props: {
    titleProps: {
      type: String,
      default: ""
    },
    isToggle: {
      type: Boolean,
      default: false
    },
    showHome: {
      type: Boolean,
      default: true
    },
    showBack: {
      type: Boolean,
      default: false
    },
    noBottomLine: {
      type: Boolean,
      default: false
    },
    customGoBack: {
      type: Boolean,
      default: false
    },
    custonmClass: {
      type: String,
      default: ""
    },
    headrTitle: {
      type: String,
      default: ""
    }
  },
  computed: {
    routerTitle() {
      const self = this;
      let title = "";
      this.$router.options.routes.forEach(el => {
        (function loopChild(child) {
          if (child.name === self.$route.name) {
            return (title = child.title);
          }
          if (!child.children) {
            return;
          }
          child.children.forEach(loopChild);
        })(el);
      });
      return title;
    }
  },
  components: {
    icon
  },
  mounted() {
    const that = this;
    that.sourceForm = getQueryUrl("from") || "h5";
  },
  methods: {
    onHomeClick() {
      if (cookie(CONSTANT.COOKIE_CO) == CONSTANT.COOKIE_CO_IS_QYG) {
        window.location.href = CONSTANT.COOKIE_QYG_CALLBACK_URL;
        return;
      }
      this.$router.push("/");
      this.$emit("on-home-click");
    },
    goBack() {
      if (this.customGoBack) {
        this.$emit("customGoBack");
        return;
      }
      if (this.isToggle) {
        return this.$emit("toggle-search");
      }
      if (document.referrer.match(CONSTANT.ORIGIN_HOST)) {
        return this.$router.go(-1);
      }
      if (window.history.length == 2) {
        return this.onHomeClick();
      }
      history.back();
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../stylesheet/variable";

@inkGrey: rgb(46, 47, 48);
header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: @headerHeight;
  overflow: hidden;
  margin: 0;
  padding: 0;
  z-index: 300;
  background-color: #ffffff;
  & > div {
    float: left;
    height: @headerHeight;
  }
  &::after {
    .setBottomLine();
  }
  i {
    display: block;
    font-size: 23px;
    color: @inkGrey;
  }
  .left {
    width: 17%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    & > i {
      margin-left: 10px;
    }
    & > img {
      margin-left: 14px;
      vertical-align: middle;
    }
  }
  .title {
    width: 66%;
    text-align: center;
    font-size: 17px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: @inkGrey;
    div {
      color: @inkGrey;
    }
  }
  .right {
    width: 17%;
    display: flex;
    justify-content: center;
    align-items: center;
    div {
      width: 100%;
      text-align: center;
    }
  }
}
.header-no-bottom-line {
  &::after {
    display: none;
  }
}
</style>
